import { Injectable } from '@angular/core';
import { ModuleTypes } from '../shared/module-types';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor() { }


  changeDocumentName(docs, moduleType) {
    switch (moduleType) {
      case ModuleTypes.Preboarding:
        docs.forEach(doc => {
          const str = doc.fileName.split(".");
          doc.fileName = doc.document.displayText.replace("GPN_", '') + "." + str[str.length - 1];
        });
        break;
      default:
        docs.forEach(doc => {
          const str = doc.fileName.split(".");
          doc.fileName = doc.documentName.replace("GPN_", '') + "." + str[str.length - 1];
        });
        break;
    }
    return docs;
  }

  updateCandidateDocs(docs, disabled: boolean, candidateDocs) {
    docs.forEach(item => {
      let resIndex = candidateDocs.findIndex(x => x.fileGuiId == item.fileGuiId);
      if(resIndex && resIndex>0){
        candidateDocs[resIndex].disabled = disabled;
      }

    });
    candidateDocs = candidateDocs.slice(0, candidateDocs.length);
    return candidateDocs;
  }
}
